// Same production-only bootstrap, IDs and pre-React load position as the main
// website. GTM/Google owns GA4 page views; Meta owns its automatic SPA tracking.
let initialized = false;
export function initMarketingTags() {
  if (initialized) return;
  initialized = true;
  if (!['prod', 'production'].includes(process.env.REACT_APP_MARKETING_MODE)) return;
  const gtmId = process.env.REACT_APP_GTM_ID;
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  window.dataLayer = window.dataLayer || [];
  if (gtmId) {
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    if (document.body) {
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0'; iframe.width = '0';
      iframe.style.display = 'none'; iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }
  if (pixelId) {
    if (!window.fbq) {
      const fbq = function (...args) {
        if (fbq.callMethod) fbq.callMethod(...args);
        else fbq.queue.push(args);
      };
      fbq.queue = []; fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0';
      window.fbq = fbq; window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      first?.parentNode?.insertBefore(script, first);
    }
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }
}

// Delegation covers prerendered article links and later client-side navigation
// without modifying copy, destinations or conversion tags in the container.
export function initBlogCtaEvents() {
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, window.location.href);
    const playground = ['playground.safevaultusa.com', 'play.safevaultusa.com'].includes(url.hostname);
    const demo = url.pathname === '/schedule-demo';
    if (!playground && !demo) return;
    const cta_location = anchor.closest('header') ? 'navbar' : anchor.closest('footer') ? 'footer' : anchor.closest('aside') ? 'sidebar' : 'blog_article';
    (window.dataLayer ||= []).push({
      event: playground ? 'playground_cta_click' : 'cta_click',
      page_path: window.location.pathname,
      cta_location,
      ...(demo ? { label: anchor.textContent.trim(), location: cta_location } : {}),
    });
  });
}
